<template>
  <div>
    <el-tabs v-model="activeName" type="card" @tab-click="handleClick">
      <el-tab-pane
        v-for="(item, index) in activeNameList"
        :key="'activeNameList' + index"
        :label="setActiveName(item.label, item.value)"
        :name="item.name"
      ></el-tab-pane>
    </el-tabs>
    <div class="selectBox">
      <el-form ref="paramsList" :model="params">
        <!-- eslint-disable-next-line vue/no-unused-refs -->
        <QS-search maxLine="1" ref="BLM-search">
          <!-- 内容区域-->
          <el-form-item label="车牌号" prop="plateNo">
            <el-select
              v-model="params.plateNo"
              filterable
              remote
              reserve-keyword
              placeholder="请输入"
              :remote-method="(query) => { remoteMethod(query) }"
              :loading="oLoading.fuzzy"
            >
              <el-option
                v-for="item in options"
                :key="item.plateNo"
                :label="item.plateNo"
                :value="item.plateNo"
              />
            </el-select>
          </el-form-item>
          <el-form-item prop="carId" label="车辆ID">
            <el-input
              v-number:integer="18"
              v-model="params.carId"
              placeholder="请输入车辆ID"
              clearable
            />
          </el-form-item>

          <CarBrandSeriesModel
            ref="carBrandSeriesModelRef"
            v-model="brandSeriesModel"
            :showModel="true"
            :filterScene="CAR_MODEL_FILTER_SCENE.IN_STOCK"
          ></CarBrandSeriesModel>
          <!--车辆标签-->
          <el-form-item label="车辆标签" prop="carTagId">
            <el-select v-model="params.carTagId" clearable placeholder="请选择车辆标签">
              <el-option value="" label="全部" />
              <el-option
                v-for="item in allTagList"
                :label="item.name"
                :value="item.id"
                :key="item.id"
              />
            </el-select>
          </el-form-item>
          <!--车辆状态-->
          <el-form-item label="车辆状态" prop="carState">
            <el-select v-model="params.carState" clearable placeholder="请选择车辆状态">
              <el-option value="" label="全部" />
              <el-option
                v-for="item in vehicleStatusList"
                :label="item.label"
                :value="item.value"
                :key="item.value"
              />
            </el-select>
          </el-form-item>
          <!--车辆创建时间-->
          <el-form-item prop="theCarStartAndFinish" label="车辆创建时间">
            <el-date-picker
              v-model="params.theCarStartAndFinish"
              format="yyyy-MM-dd"
              value-format="yyyy-MM-dd HH:mm:ss"
              type="daterange"
              range-separator="至"
              start-placeholder="开始日期"
              end-placeholder="结束日期"
              clearable
              @change="timeSplit(params.theCarStartAndFinish)"
              :default-time="['00:00:00', '23:59:59']"
            />
          </el-form-item>
          <el-form-item prop="vin" label="VIN码">
            <el-input
              v-model="params.vin"
              v-uppercase="true"
              placeholder="请输入VIN码"
              clearable
              maxlength="17"
              @input="changeVIN"
            />
          </el-form-item>
          <el-form-item prop="deptIdList" label="所属部门">
            <DeptSelect v-model="params.deptIdList" filterable clearable multiple />
          </el-form-item>
          <!-- 按钮区域，slot方式，各个按钮要单独用item包裹-->
          <template slot="moreBtn">
            <el-form-item>
              <el-button
                :loading="oLoading.search"
                type="primary"
                size="small"
                @click="selectBtn"
              >查询</el-button>
            </el-form-item>
            <el-form-item>
              <el-button size="small" @click="Reset"> 重置 </el-button>
            </el-form-item>
            <el-form-item>
              <el-button
                v-if="judgePermission('vehicle_licences_list_export')"
                :loading="oLoading.export"
                @click="asyncExportHandle"
              >导出数据</el-button>
            </el-form-item>
            <el-form-item>
              <el-button
                v-if="judgePermission('vehicle_licences_list_export')"
                @click="exportDataHandle"
              >导出列表</el-button>
            </el-form-item>
            <el-form-item>
              <el-button
                v-if="judgePermission('vehicle-licences-export-rules-setting')"
                size="small"
                @click="setRemindRules"
              >配置证照逾期提醒日期</el-button>
            </el-form-item>
          </template>
        </QS-search>
      </el-form>
    </div>
    <div>
      <el-button
        v-if="judgePermission('vehicle_licences_list_create')"
        type="primary"
        @click="addCarLicence"
      >新建证照</el-button>
      <el-button
        v-if="judgePermission('vehicle_licences_batch_export')"
        @click="uploadCarLicence"
      >批量导入证照</el-button>
    </div>
    <div class="content mt16">
      <QS-common-table
        :data="tableData"
        :columns="headColumn"
        :loading="oLoading.search"
        :pagination="paginationData"
        @change="pageEvent"
      />
    </div>
    <ImportPopup
      ref="importPopup"
      title="批量导入证件图片"
      :upload="upload"
      @validate="validate"
      @close="closeWrap"
    >
      <div class="container">
        <img :src="require('@/assets/img/instructions.png')" />
      </div>
      <el-form :inline="true" ref="upload" :model="imageParams" :rules="rules">
        <el-form-item label="选择导入类型" prop="imgType">
          <el-select
            v-model="imageParams.imgType"
            clearable
            placeholder="请选择"
            @change="imageFieldChange"
            :disabled="importPopupShow"
          >
            <el-option
              v-for="item in imgTypeList"
              :label="item.label"
              :value="item.value"
              :key="item.value"
            />
          </el-select>
        </el-form-item>
      </el-form>
    </ImportPopup>
    <!--证照逾期提醒日期弹窗配置-->
    <el-dialog
      :visible.sync="remindRuleDialogShow"
      title="配置证照逾期提醒日期"
      width="400px">
      <div>
        <el-form
          ref="remindFrom"
          label-width="80px"
          label-position="right"
          :model="remindRules"
          :rules="remindFormRule">
          <el-form-item label="年审" prop="yearInspectRemindDay">
            <el-input-number
              v-model="remindRules.yearInspectRemindDay"
              placeholder="请输入逾期提醒天数"
              :min="1"
              :max="90"
              :step="1"
              step-strictly
              :controls="false"
              class="remind-rule-item"
            />
          </el-form-item>
          <el-form-item label="网约车证" prop="transportLicenseRemindDay">
            <el-input-number
              v-model="remindRules.transportLicenseRemindDay"
              placeholder="请输入逾期提醒天数"
              :min="1"
              :max="90"
              :step="1"
              step-strictly
              :controls="false"
              class="remind-rule-item"
            />
          </el-form-item>
          <el-form-item label="交强险" prop="compulsoryInsuranceRemindDay">
            <el-input-number
              v-model="remindRules.compulsoryInsuranceRemindDay"
              placeholder="请输入逾期提醒天数"
              :min="1"
              :max="90"
              :step="1"
              step-strictly
              :controls="false"
              class="remind-rule-item"
            />
          </el-form-item>
          <el-form-item label="商业险" prop="commercialInsuranceRemindDay">
            <el-input-number
              v-model="remindRules.commercialInsuranceRemindDay"
              placeholder="请输入逾期提醒天数"
              :min="1"
              :max="90"
              :step="1"
              step-strictly
              :controls="false"
              class="remind-rule-item"
            />
          </el-form-item>
        </el-form>
        <div class="remind-rules-footer">
          <el-button size="large" @click="remindRuleDialogShow = false">取消</el-button>
          <el-button type="primary" @click="saveRemindRules">确认</el-button>
        </div>
      </div>
    </el-dialog>
    <!-- 导出列表 -->
    <export-list-dialog
      v-if="dialogObj.visible"
      :dialogVisible="dialogObj.visible"
      :taskType="6"
      filename="车辆证照管理列表"
      @close="dialogObj.visible = false"
    />
  </div>
</template>
<script>
// eslint-disable-next-line import/no-cycle
import { FuzzySearch, LicenseStateSummary, licenseList, getcarAuditRecord, exportViolationManage, editRemindConfig, remindConfigDetail } from '@/api/domain/cars'
import { getTenantCustomTagList } from '@/api/domain/organize' // 引入车辆标签接口
import CARDICT from '@/store/dict/carDict.js'
import selectOption from '@/store/dict/selectOptionDict'
import { addLongTermText } from '@/utils'
import { mapGetters } from 'vuex'
import { uploadTaskCreate } from '@/api/domain/others.js'
import ImportPopup from '@/components/ImportPopup'
import * as Sentry from '@sentry/vue'
import exportListDialog from '@/pages/orders/overdue/components/exportListDialog.vue'
import { operateMaxShowLength } from '@/store/dict/config'
import { CAR_MODEL_FILTER_SCENE } from '@/config/carManage'

export default {
  components: {
    ImportPopup,
    exportListDialog,
  },
  data() {
    return {
      importPopupShow: false, // 导入弹窗展示
      oLoading: {
        fuzzy: false,
        search: false,
        export: false,
      },
      activeName: '0',
      allTagList: [],
      activeNameList: [
        {
          label: '全部车辆',
          name: '0',
          key: 'allCarNum',
          value: '',
        },
        {
          label: '车辆信息不完整',
          name: '1',
          key: 'infoDefectCarNum',
          value: '',
        },
        {
          label: '年审临过期',
          name: '2',
          key: 'yearInspectOverDueCarNum',
          value: '',
        },
        {
          label: '车证临过期',
          name: '3',
          key: 'transportLicenseOverDueCarNum',
          value: '',
        },
        {
          label: '违章待处理',
          name: '4',
          key: 'illegalToHandleCarNum',
          value: '',
        },
        {
          label: '交强险临过期',
          name: '5',
          key: 'compulsoryInsuranceOverDueCarNum',
          value: '',
        },
        {
          label: '商业险临过期',
          name: '6',
          key: 'commercialInsuranceOverDueCarNum',
          value: '',
        },
        {
          label: '维保事故中',
          name: '7',
          key: 'maintenanceAccidentCarNum',
          value: '',
        },
      ],
      params: {
        vin: '', // VIN码
        carId: '', // 车辆id
        plateNo: '', // 车牌号
        carTagId: '', // 车辆标签
        carState: '', // 车辆状态
        startDate: '', // 开始时间
        endDate: '', // 结束时间
        theCarStartAndFinish: '', // 接收开始时间和结束时间
        tabNo: 0,
        pageSize: 10,
        pageNum: 1,

        inventoryState: '', // 库存状态
        value1: '', // 年检到期日
        value2: '', // 网约车证到期日
        value3: '', // 强制报废日期
        inspectDateBegin: '', // 年检到期 开始
        inspectDateEnd: '', // 年检到期 结束
        expiryDateBegin: '', // 网约车到期日开始
        expiryDateEnd: '', // 网约车到期日结束
        scrapDateBegin: '', // 强制报废期日开始
        scrapDateEnd: '', // 强制报废期日结束
        operateState: '', // 运营状态
        deptIdList: [], // 所属部门
      },
      brandSeriesModel: {},
      total: 10,
      headColumn: [
        {
          name: 'carId',
          columnProps: {
            label: '车辆ID',
            prop: 'carId',
            width: 110,
          },
          render: ({ row }) => {
            if (this.judgePermission('vehicle_list_detail')) {
              return (
                row.carId && (<a class="cursor-point"> <span onClick={() => this.JumpCarDetail(row)}>{row.carId}</span></a>)
              )
            } else {
              return <span>{row.carId}</span>
            }
          },
        },
        {
          name: 'brandName',
          columnProps: {
            prop: 'brandName',
            label: '品牌',
            width: 120,
          },
        },
        {
          name: 'seriesName',
          columnProps: {
            prop: 'seriesName',
            label: '车系',
            width: 120,
          },
        },
        {
          name: 'model',
          columnProps: {
            label: '车型',
            prop: 'model',
            width: 160,
          },
        },
        {
          name: 'plateNo',
          columnProps: {
            label: '车牌号',
            prop: 'plateNo',
            width: 120,
          },
        },
        {
          name: 'vin',
          columnProps: {
            label: 'VIN码',
            prop: 'vin',
            width: 180,
          },
        },
        {
          name: 'engineNo',
          columnProps: {
            label: '发动机号',
            prop: 'engineNo',
            width: 160,
          },
        },
        {
          name: 'licenseOwner',
          columnProps: {
            label: '行驶证所有人',
            prop: 'licenseOwner',
            width: 160,
          },
        },
        {
          name: 'basicItemState',
          columnProps: {
            label: '车辆基本信息状态',
            prop: 'basicItemState',
            width: 140,
          },
          render: ({ row }) => {
            const routeUrl = this.$router.resolve({
              path: '/vehicle/vehicleManage/detail',
            })
            if (row.basicItemState === 1 || row.basicItemState === 2 || row.basicItemState === 3 || !row.basicItemState) {
              return <span class="yearInspectDate_blue cursor-point" onClick={() => window.open(`${routeUrl.href}?id=${row.carId}&source=${this.moduleName}`)}>{CARDICT.CAR_MESSAGE()[row.basicItemState]}</span>
            } else {
              return <span>{CARDICT.CAR_MESSAGE()[row.basicItemState]}</span>
            }
          },
        },
        {
          name: 'yearInspectDate',
          columnProps: {
            label: '年审有效期',
            prop: 'yearInspectDate',
            width: 140,
          },
          render: ({ row }) => {
            return row.yearInspectDate ?
              <span>{row.yearInspectDate}</span> : <span>--</span>
          },
        },
        {
          name: 'yearInspectOverDueDays',
          columnProps: {
            label: '年审逾期时间',
            prop: 'yearInspectOverDueDays',
            width: 140,
          },
          render: ({ row }) => {
            // 已过期
            if (row.yearInspectStatus === 3) {
              return <span class="yearInspectDate_red">{row.yearInspectOverDueDays}天</span>
            }
            // 即将到期且天数为0
            if (row.yearInspectStatus === 5 && row.yearInspectOverDueDays === 0) {
              return <span class="yearInspectDate_red">{row.yearInspectOverDueDays}天</span>
            }
            // 即将到期显示天数，state为1显示--
            return row.yearInspectStatus === 5 ?
              <span>{row.yearInspectOverDueDays}天</span> : <span>--</span>
          },
        },
        {
          name: 'transportLicenseDate',
          columnProps: {
            label: '网约车证有效期',
            prop: 'transportLicenseDate',
            width: 140,
          },
          render: ({ row }) => {
            return row.transportLicenseDate ?
              <span>{row.transportLicenseDate}</span> : <span>--</span>
          },
        },
        {
          name: 'transportLicenseOverDueDays',
          columnProps: {
            label: '车证逾期时间',
            prop: 'transportLicenseOverDueDays',
            width: 140,
          },
          render: ({ row }) => {
            // 已过期
            if (row.transportLicenseStatus === 3) {
              return <span class="yearInspectDate_red">{row.transportLicenseOverDueDays}天</span>
            }
            // 即将到期且天数为0
            if (row.transportLicenseStatus === 5 && row.transportLicenseOverDueDays === 0) {
              return <span class="yearInspectDate_red">{row.transportLicenseOverDueDays}天</span>
            }
            // 即将到期显示天数，state为1显示--
            return row.transportLicenseStatus === 5 ?
              <span>{row.transportLicenseOverDueDays}天</span> : <span>--</span>
          },
        },
        {
          name: 'compulsoryInsuranceDate',
          columnProps: {
            label: '交强险有效期',
            prop: 'compulsoryInsuranceDate',
            width: 140,
          },
          render: ({ row }) => {
            return row.compulsoryInsuranceDate ?
              <span>{row.compulsoryInsuranceDate}</span> : <span>--</span>
          },
        },
        {
          name: 'compulsoryInsuranceOverDueDays',
          columnProps: {
            label: '交强险逾期时间',
            prop: 'compulsoryInsuranceOverDueDays',
            width: 140,
          },
          render: ({ row }) => {
            // 已过期
            if (row.compulsoryInsuranceStatus === 3) {
              return <span class="yearInspectDate_red">{row.compulsoryInsuranceOverDueDays}天</span>
            }
            // 即将到期且天数为0
            if (row.compulsoryInsuranceStatus === 5 && row.compulsoryInsuranceOverDueDays === 0) {
              return <span class="yearInspectDate_red">{row.compulsoryInsuranceOverDueDays}天</span>
            }
            // 即将到期显示天数，state为1显示--
            return row.compulsoryInsuranceStatus === 5 ?
              <span>{row.compulsoryInsuranceOverDueDays}天</span> : <span>--</span>
          },
        },
        {
          name: 'commercialInsuranceDate',
          columnProps: {
            label: '商业险有效期',
            prop: 'commercialInsuranceDate',
            width: 140,
          },
          render: ({ row }) => {
            return row.commercialInsuranceDate ?
              <span>{row.commercialInsuranceDate}</span> : <span>--</span>
          },
        },
        {
          name: 'commercialInsuranceOverDueDays',
          columnProps: {
            label: '商业险逾期时间',
            prop: 'commercialInsuranceOverDueDays',
            width: 140,
          },
          render: ({ row }) => {
            // 已过期
            if (row.commercialInsuranceStatus === 3) {
              return <span class="yearInspectDate_red">{row.commercialInsuranceOverDueDays}天</span>
            }
            // 即将到期且天数为0
            if (row.commercialInsuranceStatus === 5 && row.commercialInsuranceOverDueDays === 0) {
              return <span class="yearInspectDate_red">{row.commercialInsuranceOverDueDays}天</span>
            }
            // 即将到期显示天数，state为1显示--
            return row.commercialInsuranceStatus === 5 ?
              <span>{row.commercialInsuranceOverDueDays}天</span> : <span>--</span>
          },
        },
        {
          name: 'carLicenseRemindConfigVO',
          columnProps: {
            label: '逾期规则',
            prop: 'carLicenseRemindConfigVO',
            width: 150,
          },
          render: ({ row }) => {
            if (!row.carLicenseRemindConfigVO) return <span>--</span>
            const { carLicenseRemindConfigVO } = row
            return <div>
              <p>年审: {carLicenseRemindConfigVO.yearInspectRemindDay}天</p>
              <p>网约车证: {carLicenseRemindConfigVO.transportLicenseRemindDay}天</p>
              <p>交强险: {carLicenseRemindConfigVO.compulsoryInsuranceRemindDay}天</p>
              <p>商业险: {carLicenseRemindConfigVO.commercialInsuranceRemindDay}天</p>
            </div>
          },
          columnHeaderTooltip: '证件逾期时间展示为红色负数时证明证件已过期',
        },
        {
          name: 'illegalScore',
          columnProps: {
            label: '违章扣分',
            prop: 'illegalScore',
            width: 140,
          },
          render: ({ row }) => {
            if (!row.illegalScore || Number(row.illegalScore) === 0) {
              return <span>{row.illegalScore}分</span>
            } else {
              return <span class="yearInspectDate_red">{row.illegalScore}分</span>
            }
          },
        },
        {
          name: 'illegalAmount',
          columnProps: {
            label: '违章罚款',
            prop: 'illegalAmount',
            width: 140,
          },
          render: ({ row }) => {
            if (!row.illegalAmount || row.illegalAmount === '0.00') {
              return <span>{row.illegalAmount}元</span>
            } else {
              return <span class="yearInspectDate_red">{row.illegalAmount}元</span>
            }
          },
        },
        {
          name: 'operateState',
          columnProps: {
            label: '运营状态',
            prop: 'operateState',
            width: 120,
          },
          render: ({ row }) => {
            if (row.operateState === 2 || row.operateState === 3 || row.operateState === 4) {
              return (
                <div class="flex">
                  <span class="yearInspectDate_red">{selectOption.carOperateStateDict[row.operateState]}</span>
                </div>
              )
            } else {
              return (
                <div class="flex">
                  <span>{selectOption.carOperateStateDict[row.operateState]}</span>
                </div>
              )
            }
          },
        },
        {
          name: 'carTags',
          columnProps: {
            label: '车辆标签',
            prop: 'carTags',
          },
          render: ({ row }) => {
            if (row && row.carTags) {
              const result = row.carTags.map((item) => {
                return (
                  <el-tag size="mini">{item}</el-tag>
                )
              })
              return result
            } else {
              return '--'
            }
          },
        },
        {
          name: 'carState',
          columnProps: {
            label: '车辆状态',
            prop: 'carState',
          },
          getText: ({ row }) => this.carStateList[row.carState],
        },
        {
          name: 'createTime',
          columnProps: {
            label: '车辆创建时间',
            prop: 'createTime',
            width: 180,
          },
        },
        {
          name: 'deptName',
          columnProps: {
            label: '所属部门',
            prop: 'deptName',
          },
        },
        {
          name: 'operate',
          columnProps: {
            label: '操作',
            fixed: 'right',
            width: 240,
          },
          maxShowLength: operateMaxShowLength,
          type: 'operate',
          getOperateList: ({ row }) => {
            const result = []
            if (this.judgePermission('vehicle_licences_list_edit')) {
              result.push({ name: 'edit', label: '编辑', action: () => this.JumpCarEdit(row) })
            }
            if (row.basicItemState === 2 && row.carState !== 5 && this.judgePermission('vehicle_licences_list_submit')) {
              result.push({ name: 'info', label: '车辆信息提交', action: () => this.carManageSubmit(row) })
            }
            return result
          },
        },
      ],
      tableData: [],
      options: [],
      imageParams: {}, // 图片上传
      imgTypeList: [
        {
          label: '行驶证照片（主页）',
          value: 30,
        },
        {
          label: '行驶证照片（副页）',
          value: 33,
        },
        {
          label: '登记证照片',
          value: 31,
        },
        {
          label: '网约车证照片',
          value: 32,
        },
      ], // 图片上传列表
      rules: {
        imgType: [
          {
            required: true,
            message: '导入类型不能为空',
            trigger: 'change',
          },
        ],
      },
      moduleName: 'licence', // 模块标识「用于详情页面匹配」
      remindRuleDialogShow: false, // 证照逾期规则是否显示
      remindRules: {
        yearInspectRemindDay: undefined,
        transportLicenseRemindDay: undefined,
        compulsoryInsuranceRemindDay: undefined,
        commercialInsuranceRemindDay: undefined,
      },
      remindFormRule: {
        yearInspectRemindDay: [{ required: true, message: '请输入逾期提醒天数', trigger: 'blur' }],
        transportLicenseRemindDay: [{ required: true, message: '请输入逾期提醒天数', trigger: 'blur' }],
        compulsoryInsuranceRemindDay: [{ required: true, message: '请输入逾期提醒天数', trigger: 'blur' }],
        commercialInsuranceRemindDay: [{ required: true, message: '请输入逾期提醒天数', trigger: 'blur' }],
      },
      dialogObj: { // 弹框相关参数，其他参数根据自身弹框扩展
        visible: false, // 显隐
      },
      CAR_MODEL_FILTER_SCENE,
    }
  },
  mounted() {
    this.getLicenseStateSummary()
    this.getList()
    this.getTenantCustomTagList() // 获取车辆标签
  },
  methods: {
    // 根据状态返回类名
    // eslint-disable-next-line vue/no-unused-properties
    getClassName(row) {
      // 已暂停显示灰色
      if (row.compulsoryInsuranceStatus === 3 || row.compulsoryInsuranceStatus === 2) return 'yearInspectDate_red'
      return 'yearInspectDate_blue'
    },
    // 批量导入校验
    validate(callback) {
      this.$refs.upload.validate((valid) => {
        if (valid) {
          callback()
        }
      })
    },
    // 选中上传类型
    imageFieldChange(val) {
      this.imageParams.imgType = val
    },
    // 新增证照
    addCarLicence() {
      this.$router.push({
        path: '/vehicle/licences/add',
      })
    },
    // 证照
    uploadCarLicence() {
      this.$router.push({
        path: '/vehicle/newCarInStock/add',
        query: {
          scene: 'licencesList',
        },
      })
    },
    // 导入返回值
    upload(url, file) {
      return new Promise((resolve, reject) => {
        if (this.imageParams.imgType === '' || url === '') return
        this.importPopupShow = true
        uploadTaskCreate({
          uploadType: this.imageParams.imgType,
          fileAddress: url,
          fileName: file.name,
        })
          .then((res) => {
            const { code } = res
            this.$refs.importPopup.closeDialog()
            if (code === 1) {
              this.$confirm('上传成功', '提示', {
                confirmButtonText: '查看导入历史',
                cancelButtonText: '取消',
              }).then(() => {
                this.$router.push({
                  name: 'vehicleImageImportHistory',
                })
              // eslint-disable-next-line @typescript-eslint/no-empty-function
              }).catch(() => {})
              this.selectBtn()
              this.imageParams.imgType = ''
              resolve()
            } else {
              this.imageParams.imgType = ''
              reject()
            }
          })
          .catch(() => {
            this.$refs.importPopup.closeDialog()
            reject()
          })
      })
    },
    changeVIN() {
      const reg = /^[0-9A-Z]/
      let str = ''
      for (let i = 0; i < this.params.vin.length; i++) {
        if (reg.test(this.params.vin[i])) {
          str += this.params.vin[i]
        }
      }
      this.params.vin = str
    },
    handleClick(tab) {
      if (this.params.tabNo === parseInt(tab.name)) return
      this.params.tabNo = parseInt(tab.name)
      this.Reset()
    },
    /* 获取车险统计 */
    async getLicenseStateSummary() {
      try {
        const { data } = await LicenseStateSummary()
        if (data) {
          Object.keys(data).forEach((item) => {
            this.activeNameList.forEach((items) => {
              if (item === items.key) {
                items.value = data[item]
              }
            })
          })
        }
      } catch (error) {
        Sentry.captureException(error)
      }
    },
    /* 获取列表 1 */
    async getList() {
      this.oLoading.search = true
      try {
        const _params = {
          ...this.params,
          deptIdList: this.params.deptIdList || [],
        }

        if (_params.carId) {
          _params.carId = parseInt(_params.carId)
        }
        const { code, data } = await licenseList(_params)
        this.oLoading.search = false
        if (code === 1) {
          this.tableData = data.items.map((item) => {
            if (item.illegalScore == null) {
              item.illegalScore = '0.00'
            }
            // 显示为长期
            item.yearInspectDate = addLongTermText(item.yearInspectDate)
            item.transportLicenseDate = addLongTermText(
              item.transportLicenseDate,
            )
            item.compulsoryInsuranceDate = addLongTermText(
              item.compulsoryInsuranceDate,
            )
            item.commercialInsuranceDate = addLongTermText(
              item.commercialInsuranceDate,
            )
            return { ...item }
          })

          this.total = data.totalNum
        }
      } catch (error) {
        this.oLoading.search = false
      }
    },
    // 获取车辆标签
    getTenantCustomTagList() {
      getTenantCustomTagList({
        type: 1,
      }).then((res) => {
        const { code, data } = res
        if (code === 1) {
          this.allTagList = data
        }
      })
    },

    /* 跳转车辆详情 */
    JumpCarDetail(data) {
      this.$router.push({
        path: '/vehicle/vehicleManage/detail',
        query: {
          id: data.carId,
          source: this.moduleName,
        },
      })
    },
    /* 跳转证照编辑 */
    JumpCarEdit(data) {
      if (data.basicItemState === 3) {
        const str =
          '审核中，车辆不可编辑信息，提示车辆信息审核中，请审核结束后再修改'
        this.$alert(str, '提示', {
          confirmButtonText: '确定',
          // eslint-disable-next-line @typescript-eslint/no-empty-function
          callback: () => {},
        })
      } else {
        this.$router.push({
          path: '/vehicle/licences/edit',
          query: {
            id: data.carId,
          },
        })
      }
    },
    timeSplit(data) {
      this.params.startDate = data[0]
      this.params.endDate = data[1]
    },
    /* 查询 */
    selectBtn() {
      this.params.pageNum = 1
      this.getList()
    },
    /* 车辆模糊搜索 */
    async remoteMethod(query) {
      if (query.length >= 4) {
        // 开启远程搜索
        this.oLoading.fuzzy = true
        try {
          const { code, data } = await FuzzySearch({
            plateNo: query,
            state: 2,
          })
          // 关闭远程搜索
          this.oLoading.fuzzy = false
          if (code === 1) {
            this.options = data
          }
        } catch (error) {
          this.oLoading.fuzzy = false
        }
      }
    },
    /* 分页 */
    pageEvent({ pagination }) {
      this.params.pageSize = pagination.pageSize
      this.params.pageNum = pagination.pageNum
      this.getList()
    },
    /* 重置 */
    Reset() {
      this.$refs.paramsList.resetFields()
      this.params.pageNum = 1
      this.params.pageSize = 10
      this.params.startDate = ''
      this.params.endDate = ''
      this.$refs.carBrandSeriesModelRef.reset()
      this.brandSeriesModel = {}
      this.$nextTick(() => {
        this.getList()
      })
    },
    /* 点击车辆信息提交 */
    async carManageSubmit({ carId }) {
      this.$confirm('确定要将此车辆信息提交吗？', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
      }).then(async () => {
        const { code } = await getcarAuditRecord({
          carId,
          type: 1,
        })
        if (code === 1) {
          this.$message({
            message: '车辆信息提交成功',
            type: 'success',
          })
          this.getList()
        }
      // eslint-disable-next-line @typescript-eslint/no-empty-function
      }).catch(() => {})
    },
    // 批量证照导入关闭
    closeWrap() {
      this.$refs.upload.resetFields()
      this.importPopupShow = false
    },
    setRemindRules() {
      this.getRemindConfigDetail()
      this.remindRuleDialogShow = true
    },
    saveRemindRules() {
      this.$refs.remindFrom.validate((valid) => {
        if (!valid) return
        editRemindConfig(this.remindRules).then(() => {
          this.remindRuleDialogShow = false
          this.$message.success('配置提交后会预计在24小时后上线更新列表数据')
        }).catch((error) => {
          Sentry.captureException(error)
        })
      })
    },
    getRemindConfigDetail() {
      remindConfigDetail().then(({ code, data }) => {
        if (code === 1) {
          this.remindRules = {
            commercialInsuranceRemindDay: data.commercialInsuranceRemindDay,
            compulsoryInsuranceRemindDay: data.compulsoryInsuranceRemindDay,
            transportLicenseRemindDay: data.transportLicenseRemindDay,
            yearInspectRemindDay: data.yearInspectRemindDay,
          }
        }
      })
    },
    // 异步导出数据
    async asyncExportHandle() {
      this.oLoading.export = true
      exportViolationManage(this.exportParams).then(({ code }) => {
        if (code === 1) {
          this.$message.success('所选数据已生成下载文件，请点击【导出列表】查看下载')
        }
        this.oLoading.export = false
      }).catch((e) => {
        Sentry.captureException(e)
        this.oLoading.export = false
      })
    },
    // 导出列表
    exportDataHandle() {
      this.dialogObj.visible = true
    },
  },
  computed: {
    ...mapGetters(['carStateList']),
    // 导出数据
    exportParams() {
      return {
        ...this.params,
        deptIdList: this.params.deptIdList || [],
      }
    },
    // 库存状态
    // eslint-disable-next-line vue/no-unused-properties
    outInStateList() {
      return this.dictParseList(CARDICT.OUT_INT_STATE(), true)
    },
    // 车辆状态
    vehicleStatusList() {
      // eslint-disable-next-line vue/no-side-effects-in-computed-properties
      delete this.carStateList[999]
      return this.dictParseList(this.carStateList)
    },
    // tabs
    setActiveName() {
      return (label, value) => {
        if (value) {
          return `${label} ( ${value} )`
        } else {
          return `${label} ( 0 )`
        }
      }
    },
    paginationData() {
      return {
        pageSize: this.params.pageSize,
        pageNum: this.params.pageNum,
        total: this.total,
        pageSizes: [10, 20, 30, 50],
      }
    },
  },
  watch: {
    // 证照逾期规则弹窗关闭时清空表单值
    remindRuleDialogShow(newVal) {
      if (!newVal) {
        this.$refs.remindFrom && this.$refs.remindFrom.resetFields()
      }
    },
    brandSeriesModel: {
      handler(newVal) {
        const { brandId, seriesId, modelId } = newVal
        this.params.brandId = brandId
        this.params.seriesId = seriesId
        this.params.modelId = modelId
      },
      deep: true,
    },
  },
  async created() {
    // 获取车辆车务状态
    this.$store.dispatch('getVehicleState')
  },
}
</script>
<style lang="less" scoped>
.el-tabs {
  font-size: 14px;
}
.selectBox {
  .btnText {
    padding-top: 5px;
    font-size: 14px;
    color: #2e7eff;
  }
}
.content {
  max-height: 500px;
}
::v-deep .el-range-separator {
  width: 20px !important;
}
::v-deep .yearInspectDate_red {
  color: red !important;
}
::v-deep .yearInspectDate_gray{
  color: #666 !important;
}
::v-deep .yearInspectDate_blue {
  color: #0059dc !important;
}
.carId {
  cursor: pointer;
}
.container {
  margin-bottom: 16px;
  text-align: center;

  img {
    width: 100%;
  }
}
.flex{
  display: flex;
  align-items: center;
  .blue{
    ::v-deep .el-badge__content.is-dot{
      background: #0059dc !important;
      margin-top: 8px;
      margin-right: 8px;
    }
  }
  .red {
    ::v-deep .el-badge__content.is-dot{
      background: red !important;
      margin-top: 8px;
      margin-right: 8px;
    }
  }
}
.remind-rule-item {
  width: 200px;
}
.remind-rules-footer {
  display: flex;
  justify-content: center;
}
</style>
